/*
 * Query machine data
 */

import { useGetMachineStatesCategoriesQuery } from 'api';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

export interface MachineStatuses {
  timestamp?: string;
  value?: number;
  name?: string;
  end_timestamp?: string;
  status?: string;
  unit?: null;
  target?: null;
  app_name?: null;
  psu_name?: null;
}

type Response = {
  states: MachineStatuses[] | undefined;
  isLoading: boolean;
  error?: FetchBaseQueryError | SerializedError | undefined;
};

const useMachineStateProtein = (
  machineId: string,
  localStartDatetimeString: string,
  pollingInterval?: number
): Response => {
  const {
    data: states,
    isLoading,
    error
  } = useGetMachineStatesCategoriesQuery(
    {
      machineId,
      startDatetime: localStartDatetimeString
    },
    { pollingInterval }
  );


  return { states, isLoading, error };
};

export default useMachineStateProtein;
